import React from 'react'
import _ from 'lodash'
import Modal from 'reboron/OutlineModal'
import ScrollArea from 'react-scrollbar'

export class LunaModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            successContent: this.props.successContent,
            errorContent: this.props.errorContent
        }

        _.bindAll(this,
            'getContent',
            'defaultSuccess',
            'defaultError',
            'updateScrollElement'
        )
    }

    componentDidMount() {
        this.updateScrollElement()
    }

    componentDidUpdate(prevProps) {
        if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
            this.refs.modal.show()
            this.updateScrollElement()
        } else if (!this.props.showModal && this.props.showModal !== prevProps.showModal) {
            this.refs.modal.hide()
        }
    }

    updateScrollElement() {
        let _this = this
        window.requestAnimationFrame(function () {
            let node = _this.refs.modalScrollArea
            if (node !== undefined) {
                let cH = node.content.parentNode.parentNode.offsetHeight
                node.content.parentNode.style.height = cH + 'px'
                node.scrollArea.refresh()
            }
        })
    }


    defaultSuccess() {
        return (
            <div className="modal-content">
                <h1>Success!</h1>
                <p>
                    You can close this window now.
                </p>
                <button className="btn btn-medium btn-blue btn-submit" onClick={this.props.onModalHide}>Close</button>
            </div>
        )
    }

    defaultError() {
        return (
            <div className="modal-content">
                <h1>Uh Oh!</h1>
                <p>
                    Something went wrong....
                </p>
                <button className="btn btn-medium btn-blue btn-submit" onClick={this.props.onModalHide}>Close</button>
            </div>
        )
    }


    getContent() {
        switch (this.props.statusModal) {
            case 'success':
                // autohide after a 10 seconds if they haven't closed it
                return this.state.successContent ? this.state.successContent : this.defaultSuccess()
            case 'error':
                // autohide after a 10 seconds if they haven't closed it
                return this.state.errorContent ? this.state.errorContent : this.defaultError()
            default:
                return this.props.modalContent
        }
    }

    render() {
        let content = this.getContent()
        let modalStyle = {
            width: '80%',
            maxWidth: '800px'
        }

        // https://github.com/yuanyan/boron
        // Boron Modal Types: 'OutlineModal', 'ScaleModal', 'FadeModal', 'FlyModal', 'DropModal', 'WaveModal'
        return (
            <div className="modal-wrapper">
                <Modal modalStyle={modalStyle} onHide={this.props.onModalHide} ref="modal">
                    <div ref="modalContentWrapper" className="modal-content-wrapper">
                        <ScrollArea
                            ref="modalScrollArea"
                            speed={0.8}
                            className="area"
                            contentClassName="modal-scroll-area"
                            horizontal={false}>
                            {content}
                        </ScrollArea>
                    </div>
                </Modal>
            </div>
        )
    }
}
